import type { ModalSize } from '@/app/KeywordTracker/types/aiModalTypes';
import { AiAssistantLoadingIcon } from '@/components/common/AiAssistantLoadingIcon';
import Flex from '@/components/common/Flex';
import { Card } from 'react-bootstrap';

interface AnalysisLoadingStateProps {
  keyword?: string;
  isMdUp: boolean;
  size: ModalSize;
}

const loadingSteps = [
  'بررسی روند رتبه در ۳۰ روز گذشته',
  'تحلیل فرصت‌ها و چالش‌های کلمه',
  'آماده‌سازی پیشنهادهای بهبود'
];

const AnalysisLoadingState = ({
  keyword,
  isMdUp,
  size
}: AnalysisLoadingStateProps) => {
  const contentHeight = isMdUp ? size.height - 180 : 'calc(85vh - 180px)';

  return (
    <Card.Body
      as={Flex}
      alignItems="center"
      justifyContent="center"
      className="ai-analysis-loading p-0 flex-1"
      style={{ minHeight: contentHeight }}
    >
      <div className="ai-analysis-loading-panel rounded-4 text-center">
        <AiAssistantLoadingIcon className="mx-auto mb-3" />

        <h6 className="text-1000 mb-1">در حال تحلیل با هوش مصنوعی</h6>
        <p className="text-secondary fs--1 mb-0">
          {keyword ? (
            <>
              کلمه کلیدی{' '}
              <span className="ai-analysis-loading-keyword rounded-pill">
                {keyword}
              </span>
            </>
          ) : (
            'لطفاً چند لحظه صبر کنید...'
          )}
        </p>

        <ul className="ai-analysis-loading-steps list-unstyled mt-4 mb-0">
          {loadingSteps.map((step, index) => (
            <li
              key={step}
              className="ai-analysis-loading-step"
              style={{ animationDelay: `${index * 0.8}s` }}
            >
              <span className="ai-analysis-loading-step-dot" aria-hidden="true" />
              <span>{step}</span>
            </li>
          ))}
        </ul>

        <div className="ai-analysis-loading-typing mt-4" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </div>
    </Card.Body>
  );
};

export default AnalysisLoadingState;
